import { CustomerUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type CustomerModel = {
  id: string | number
}

export const fetchCustomer = ({ id }: CustomerModel) => {
  return new CustomerUseCase(
    `/clientes/getConsumer/${id}`,
    makeAxiosHttpClient()
  )
}

export const fetchCustomerCpf = (value: string) => {
  return new CustomerUseCase(
    `/clientes/getConsumerCpf?cpf=${value}`,
    makeAxiosHttpClient()
  )
}

export const createCustomer = () => {
  return new CustomerUseCase('/clientes/newConsumer', makeAxiosHttpClient())
}

export const createCustomerShort = () => {
  return new CustomerUseCase(
    '/clientes/newConsumer/short',
    makeAxiosHttpClient()
  )
}

export const updateCustomer = ({ id }: CustomerModel) => {
  return new CustomerUseCase(
    `/clientes/updateConsumer/${id}`,
    makeAxiosHttpClient()
  )
}

export const deleteCustomer = ({ id }: CustomerModel) => {
  return new CustomerUseCase(
    `/clientes/deleteConsumer/${id}`,
    makeAxiosHttpClient()
  )
}

export const deleteCustomerDocument = ({ id }: CustomerModel) => {
  return new CustomerUseCase(`/clientes/deleteDoc/${id}`, makeAxiosHttpClient())
}

export const deleteCustomerAnddress = ({ id }: CustomerModel) => {
  return new CustomerUseCase(`/clientes/deleteEnd/${id}`, makeAxiosHttpClient())
}

export const deleteCustomerContact = ({ id }: CustomerModel) => {
  return new CustomerUseCase(
    `/clientes/deleteCont/${id}`,
    makeAxiosHttpClient()
  )
}
